import type {
  ApiFeatures,
  AppConfigs,
  AppConfigsResponse,
  Features,
} from "~/types/Data/Common/appConfigs";

type ProvidedType =
  | {
      appConfig?: AppConfigs;
      baseUrl: string;
      appName: string;
      features?: Features;
      currency: string;
      langs: string[];
    }
  | undefined;

export default defineNuxtPlugin(async (nuxtApp) => {
  const { public: publicEnv } = nuxtApp.$config;
  const cmsUrl = publicEnv.CMS_URL ?? "";

  async function fetchAppConfigs(baseUrl: string) {
    const { data: config } = await useAsyncData("config", async () => {
      const { res } = await useApi<AppConfigsResponse>(
        "/api/v2/app_configs",
        {},
        {
          baseUrl,
        },
      );
      return res;
    });

    return config.value;
  }

  const config = await fetchAppConfigs(cmsUrl);

  const normalizeFeatures = (features?: ApiFeatures): Features | undefined => {
    if (!features) return undefined;

    return Object.fromEntries(
      Object.entries(features)
        .filter(([, entry]) => entry?.is_enabled)
        .map(([feature, entry]) => [feature, entry?.configs ?? {}]),
    ) as Features;
  };

  const provided: ProvidedType = {
    appConfig: config?.data,
    baseUrl: cmsUrl,
    appName: publicEnv.APP_NAME ?? "",
    features: normalizeFeatures(config?.data.features),
    currency: config?.data?.currency?.symbol ?? "EGP",
    langs: Object.keys(config?.data.selected_languages ?? {}),
  };

  return {
    provide: provided,
  };
});
